<h3>{{quiz.quizData.name}}</h3>

<mat-tab-group>
  <mat-tab label="Survey">


    <div class="training-component" *ngIf="quiz">
      <div style="margin-left: 40px;">
        <form [formGroup]="quizForm" style="align-self: row">
          <mat-form-field style="width: 20%">
            <mat-label>Name</mat-label>
            <input matInput name="name" formControlName="name" required
                   [(ngModel)]="quiz.quizData.name">
          </mat-form-field>
          <div style="flex:0 0 1%"></div>
          <mat-form-field style="width: 20%">
            <mat-label>Version Name</mat-label>
            <input matInput name="name" formControlName="versionName" required
                   [(ngModel)]="quiz.versionName">
            <span matSuffix><span class="pi pi-info-circle"
                                  pTooltip="On save if current version has answers, archived copy with previous value of this field will be created. If unchanged or empty, value will be autogenerated"></span></span>
          </mat-form-field>
          <div style="flex:0 0 1%"></div>
          <mat-form-field style="width: 20%">
            <mat-label>Unique Response Name</mat-label>
            <input matInput name="completionName" formControlName="completionName"
                   required
                   [(ngModel)]="quiz.completionName">
            <span matSuffix><span class="pi pi-info-circle"
                                  pTooltip="On save if current version has answers, archived copy with previous value of this field will be created. If unchanged or empty, value will be autogenerated"></span></span>
          </mat-form-field>
          <div style="flex:0 0 1%"></div>
          <div style="display: flex; align-items: center;">
            <mat-checkbox [(ngModel)]="quiz.isCompletionNameLocked" name="isCompletionNameLocked"
                          formControlName="isCompletionNameLocked">Locked for User
            </mat-checkbox>
          </div>
          <div style="flex:0 0 1%"></div>
          <mat-form-field style="margin: 0 20px">
            <mat-label>Authors</mat-label>
            <mat-select
              formControlName="ownerList"
              name="ownerList"
              multiple>
              <mat-option *ngFor="let user of allUsers" [value]="user">
                {{getFullName(user)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="margin: 0 20px">
            <mat-label>Notified Users</mat-label>
            <mat-select
              formControlName="notifiedList"
              name="notifiedList"
              multiple>
              <mat-option *ngFor="let user of allUsers" [value]="user">
                {{getFullName(user)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="fa fa-trash" style="margin-right: 20px;" (click)="removeItProfile()" pTooltip="Delete Survey"
               tooltipPosition="top"></div>
          <a class="fa fa-download"
             [href]="this.config.api + '/' + 'api/assessments/' + assessmentId + '/export' + '?token=' + token"></a>
        </form>
      </div>
      <div style="margin-left: 20px;">
        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; align-self: center; width: 100%; overflow-x: auto;">
          <ng-container *ngFor="let step of quiz.quizData.steps; let i = index">
            <div style="display: flex; flex-direction: row;" class="tab-header" (click)="activeTab = i; window.scrollTo(0, 0)">
              <div class="number" [ngClass]="activeTab == i ? 'active' : ''">{{i + 1}}</div>
              <mat-form-field>
                <mat-label>Section Name</mat-label>
                <input matInput name="name" required
                       [(ngModel)]="step.name">
              </mat-form-field>
              <div class="fa fa-arrow-left" *ngIf="i > 0" (click)="moveUp(quiz.quizData.steps, i)"></div>
              <div class="fa fa-arrow-right" *ngIf="i < (quiz.quizData.steps.length - 1)"
                   (click)="moveDown(quiz.quizData.steps, i)"></div>
              <div class="icon-delete-smal" (click)="removeStep(i)" pTooltip="Delete Section"
                   tooltipPosition="top"></div>
            </div>
            <div class="splitter"></div>
          </ng-container>
          <div>
            <div class="number">{{quiz.quizData.steps.length + 1}}</div>
            <div class="fa fa-plus" (click)="addStep()"></div>
          </div>
        </div>
        <div *ngFor="let step of quiz.quizData.steps; let i = index"
             [ngStyle]="{display: (i == activeTab) ? 'block' : 'none'}">
          <ng-template matStepLabel>
            <mat-form-field>
              <mat-label>Section Name</mat-label>

              <input matInput name="name" required
                     [(ngModel)]="step.name">
            </mat-form-field>
            <div class="fa fa-arrow-left" *ngIf="i > 0" (click)="moveUp(quiz.quizData.steps, i)"></div>
            <div class="fa fa-arrow-right" *ngIf="i < (quiz.quizData.steps.length - 1)"
                 (click)="moveDown(quiz.quizData.steps, i)"></div>
            <div class="icon-delete-small" (click)="removeStep(i)" pTooltip="Delete Section"
                 tooltipPosition="top"></div>
          </ng-template>
          <ng-template matStepperIcon></ng-template>
          <ng-container *ngIf="i == activeTab">
            <div *ngFor="let item of step.items;let q = index" class="item" style="margin-top: 10px; width: 100%;">
              <div style="display: flex; flex-direction: row;">
                <div style="flex:0 0 50px">
                  <div class="fa fa-arrow-up" *ngIf="q > 0" (click)="moveUp(step.items, q)"></div>
                  <div class="fa fa-arrow-down" *ngIf="q < step.items.length - 1"
                       (click)="moveDown(step.items, q)"></div>
                </div>
                <div
                  style="line-height: 28px; font-size: 17px; font-weight: 700; margin-right: 10px; white-space: nowrap;">{{i + 1}}
                  .{{q + 1}})
                </div>
                <div style="flex:1 1 calc(100% - 100px)">
                  <ng-container *ngIf="item.type == 'textQuestion'">
                    <p-editor matInput
                              type="text"
                              name="references"
                              *ngIf="item.hasDetails"
                              [(ngModel)]="item.details"
                              #description="ngModel">
                      <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                        <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                        <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                        <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
                      </p-header>
                    </p-editor>

                    <div style="display: flex; flex-direction: row;">
                      <mat-form-field style="flex:1 1 auto">
                        <mat-label>Question</mat-label>
                        <input matInput name="name" [(ngModel)]="item.name">
                      </mat-form-field>
                      <div style="flex:1 1 auto; display: flex; flex-direction: row;">
                        <mat-checkbox [(ngModel)]="item.multiple" style="padding: 0 20px;">Multiple Answers
                        </mat-checkbox>
                        <mat-checkbox [(ngModel)]="item.hasDetails" style="padding: 0 20px;">Rich Text</mat-checkbox>
                        <div class="icon-delete-small" (click)="step.items.splice(q, 1)" pTooltip="Delete Question"
                           tooltipPosition="top"></div>
                      </div>
                    </div>
                    <div>
                      <button mat-raised-button (click)="addControlItem(item.controlItems)" style="margin: 10px 0">
                        Add Affected Control
                      </button>
                      <p-table *ngIf="item.controlItems && item.controlItems.length"
                               [value]="item.controlItems"
                               [ngStyle]="{margin: '0 0 10px 0', display: 'block'}"
                      >

                        <ng-template pTemplate="header">
                          <tr style="white-space: nowrap;font-weight: bold">
                            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                              {{col.header}}
                            </th>
                            <th style="width:15em"></th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-controlItem>
                          <tr [pSelectableRow]="controlItem">
                            <td *ngFor="let col of cols">{{controlItem[col.field]}}</td>
                            <td>
                              <button
                                type="button"
                                pButton
                                class="risksponge-button"
                                (click)="removeControlItem(item, controlItem)"
                                pTooltip="Remove Control Item" tooltipPosition="top"
                                icon="pi pi-trash">
                              </button>
                            </td>
                          </tr>
                        </ng-template>

                      </p-table>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.type == 'attachment'">
                    <p-editor matInput
                              type="text"
                              name="references"
                              *ngIf="item.hasDetails"
                              [(ngModel)]="item.details"
                              #description="ngModel">
                      <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                        <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                        <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                        <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
                      </p-header>
                    </p-editor>
                    <div style="display: flex; flex-direction: row;">
                      <mat-form-field style="width: 100%; flex:1 1 auto">
                        <mat-label>Question</mat-label>
                        <input matInput name="name" [(ngModel)]="item.name">
                      </mat-form-field>
                      <mat-checkbox [(ngModel)]="item.hasDetails" style="padding: 0 20px;">Rich Text</mat-checkbox>
                      <mat-checkbox [(ngModel)]="item.multiple" style="padding: 0 20px;">Multiple Files</mat-checkbox>
                      <div class="icon-delete-small" (click)="step.items.splice(q, 1)" pTooltip="Delete Question"
                           tooltipPosition="top"></div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.type == 'question'">
                    <p-editor matInput
                              type="text"
                              name="references"
                              *ngIf="item.hasDetails"
                              [(ngModel)]="item.details"
                              #description="ngModel">
                      <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                        <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                        <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                        <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
                      </p-header>
                    </p-editor>
                    <div style="display: flex; flex-direction: row;">
                      <mat-form-field style="width: 100%; flex:1 1 auto">
                        <mat-label>Question</mat-label>
                        <input matInput name="name" [(ngModel)]="item.name">
                      </mat-form-field>
                      <mat-checkbox [(ngModel)]="item.hasDetails" style="padding: 0 20px;">Rich Text</mat-checkbox>
                      <mat-checkbox [(ngModel)]="item.hasPleaseExplain" style="padding: 0 20px;">Include Explanation Box
                      </mat-checkbox>
                      <div class="icon-delete-small" (click)="step.items.splice(q, 1)" pTooltip="Delete Question"
                           tooltipPosition="top"></div>
                    </div>
                    <div [ngStyle]="{display: item.hasPleaseExplain ? 'flex' : 'none'}">
                      <mat-form-field style="width: 100%; flex:1 1 auto">
                        <mat-label>Prompt for User Explanation.</mat-label>
                        <input matInput name="name"
                               [(ngModel)]="item.pleaseExplainText">
                      </mat-form-field>
                    </div>
                    <div style="margin-left: 10px;" *ngIf="!item.multiple">
                      <mat-radio-group [name]="'r' + i + '_' + q" [(ngModel)]="item.correctAnswer">
                        <div *ngFor="let a of item.answers;let h = index">
                          <div style="display: flex; flex-direction: row;">
                            <div style="flex:0 0 50px">
                              <mat-radio-button [value]="h" [name]="'r' + i + '_' + q">{{'ABCDEFGHIJKL'[h]}}.
                              </mat-radio-button>
                            </div>
                            <div style="flex:1 1 auto">
                              <mat-form-field style="width: 100%">
                                <mat-label>Answer</mat-label>
                                <input matInput name="name" [(ngModel)]="a.name">
                              </mat-form-field>
                            </div>
                            <mat-select placeholder="Hide questions if selected" [(ngModel)]="a.hideIfSelected"
                                        multiple>
                              <mat-optgroup *ngFor="let step of quiz.quizData.steps, let stepNum = index"
                                            [label]="step.name">
                                <ng-container *ngFor="let que of step.items; let num = index">
                                  <mat-option *ngIf="stepNum != i || num != q"
                                              [value]="stepNum + '_' + num">{{stepNum + 1}}.{{num + 1}}
                                    ) {{que.name}}</mat-option>
                                </ng-container>
                              </mat-optgroup>
                            </mat-select>
                            <div style="flex:0 0 50px">
                              <div class="icon-delete-small" (click)="item.answers.splice(h, 1)"
                                   pTooltip="Delete Answer" tooltipPosition="top"></div>
                            </div>
                          </div>
                        </div>
                        <button mat-raised-button (click)="addControlItem(item.controlItems)" style="margin: 10px 0">
                          Recommend Controls
                        </button>
                        <p-table *ngIf="item.controlItems && item.controlItems.length"
                                 [value]="item.controlItems"
                                 [ngStyle]="{margin: '0 0 10px 0', display: 'block'}"
                        >

                          <ng-template pTemplate="header">
                            <tr style="white-space: nowrap;font-weight: bold">
                              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                                {{col.header}}
                              </th>
                              <th style="width:15em"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-controlItem>
                            <tr [pSelectableRow]="controlItem">
                              <td *ngFor="let col of cols">{{controlItem[col.field]}}</td>
                              <td>
                                <button
                                  type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="removeControlItem(item, controlItem)"
                                  pTooltip="Remove Control Item" tooltipPosition="top"
                                  icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>
                      </mat-radio-group>
                      <button mat-raised-button (click)="addAnswer(item.answers)">Add Answer</button>
                      <button mat-raised-button (click)="item.multiple = true">Change to Checkboxes</button>
                    </div>
                    <div style="margin-left: 10px;" *ngIf="item.multiple">
                      <div *ngFor="let a of item.answers;let h = index">
                        <div style="display: flex; flex-direction: row;">
                          <div style="flex:0 0 50px">
                            <mat-checkbox>{{'ABCDEFGHIJKL'[h]}}.</mat-checkbox>
                          </div>
                          <div style="flex:1 1 auto">
                            <mat-form-field style="width: 100%">
                              <mat-label>Answer</mat-label>
                              <input matInput name="name" [(ngModel)]="a.name">
                            </mat-form-field>
                          </div>
                          <mat-select placeholder="Hide questions if selected" [(ngModel)]="a.hideIfSelected" multiple>
                            <mat-optgroup *ngFor="let step of quiz.quizData.steps, let stepNum = index"
                                          [label]="step.name">
                              <ng-container *ngFor="let que of step.items; let num = index">
                                <mat-option *ngIf="stepNum != i || num != q"
                                            [value]="stepNum + '_' + num">{{que.name}}</mat-option>
                              </ng-container>
                            </mat-optgroup>
                          </mat-select>
                          <div style="flex:0 0 50px">
                            <div class="icon-delete-small" (click)="item.answers.splice(h, 1)" pTooltip="Delete Answer"
                                 tooltipPosition="top"></div>
                          </div>
                        </div>
                        <button mat-raised-button (click)="addControlItem(item.controlItems)" style="margin: 10px 0">
                          Recommend Controls
                        </button>
                        <p-table *ngIf="item.controlItems && item.controlItems.length"
                                 [value]="item.controlItems"
                                 [ngStyle]="{margin: '0 0 10px 0', display: 'block'}"
                        >

                          <ng-template pTemplate="header">
                            <tr style="white-space: nowrap;font-weight: bold">
                              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                                {{col.header}}
                              </th>
                              <th style="width:15em"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-controlItem>
                            <tr [pSelectableRow]="controlItem">
                              <td *ngFor="let col of cols">{{controlItem[col.field]}}</td>
                              <td>
                                <button
                                  type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="removeControlItem(item, controlItem)"
                                  pTooltip="Remove Control Item" tooltipPosition="top"
                                  icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>
                      </div>
                      <button mat-raised-button (click)="addAnswer(item.answers)">Add Answer</button>
                      <button mat-raised-button (click)="item.multiple = false">Change to Radio-buttons</button>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.type == 'yesNoQuestion'">
                    <p-editor matInput
                              type="text"
                              name="references"
                              *ngIf="item.hasDetails"
                              [(ngModel)]="item.details"
                              #description="ngModel">
                      <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                        <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                        <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                        <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                        <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
                      </p-header>
                    </p-editor>
                    <div style="display: flex; flex-direction: row;">
                      <mat-form-field style="width: 100%; flex:1 1 auto">
                        <mat-label>Question</mat-label>
                        <input matInput name="name" [(ngModel)]="item.name">
                      </mat-form-field>
                      <mat-checkbox [(ngModel)]="item.hasDetails" style="padding: 0 20px;">Rich Text</mat-checkbox>
                      <div class="icon-delete-small" (click)="step.items.splice(q, 1)" pTooltip="Delete Question"
                           tooltipPosition="top"></div>
                    </div>
                    <div style="margin-left: 10px;" *ngIf="!item.multiple">
                      <mat-radio-group [name]="'r' + i + '_' + q" [(ngModel)]="item.correctAnswer">
                        <div *ngFor="let a of item.answers;let h = index">
                          <div style="display: flex; flex-direction: row;">
                            <div style="flex:1 1 auto">
                              <span>Option {{'ABCDEFGHIJKL'[h]}} - {{a.name}}</span>
                              <div [ngStyle]="{display: 'flex'}">
                                <mat-form-field style="width: 100%; flex:1 1 auto">
                                  <mat-label>Enter prompt for {{a.name}} explanation</mat-label>
                                  <input matInput name="name"
                                        [(ngModel)]="a.explanationText" required>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button mat-raised-button (click)="addControlItem(item.controlItems)" style="margin: 10px 0">
                          Recommend Controls
                        </button>
                        <p-table *ngIf="item.controlItems && item.controlItems.length"
                                 [value]="item.controlItems"
                                 [ngStyle]="{margin: '0 0 10px 0', display: 'block'}"
                        >
                          <ng-template pTemplate="header">
                            <tr style="white-space: nowrap;font-weight: bold">
                              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                                {{col.header}}
                              </th>
                              <th style="width:15em"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-controlItem>
                            <tr [pSelectableRow]="controlItem">
                              <td *ngFor="let col of cols">{{controlItem[col.field]}}</td>
                              <td>
                                <button
                                  type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="removeControlItem(item, controlItem)"
                                  pTooltip="Remove Control Item" tooltipPosition="top"
                                  icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>
                      </mat-radio-group>
                    </div>
                    <div style="margin-left: 10px;" *ngIf="item.multiple">
                      <div *ngFor="let a of item.answers;let h = index">
                        <div style="display: flex; flex-direction: row;">
                          <div style="flex:0 0 50px">
                            <mat-checkbox>{{'ABCDEFGHIJKL'[h]}}.</mat-checkbox>
                          </div>
                          <div style="flex:1 1 auto">
                            <mat-form-field style="width: 100%">
                              <mat-label>Answer</mat-label>
                              <input matInput name="name" [(ngModel)]="a.name">
                            </mat-form-field>
                          </div>
                          <mat-select placeholder="Hide questions if selected" [(ngModel)]="a.hideIfSelected" multiple>
                            <mat-optgroup *ngFor="let step of quiz.quizData.steps, let stepNum = index"
                                          [label]="step.name">
                              <ng-container *ngFor="let que of step.items; let num = index">
                                <mat-option *ngIf="stepNum != i || num != q"
                                            [value]="stepNum + '_' + num">{{que.name}}</mat-option>
                              </ng-container>
                            </mat-optgroup>
                          </mat-select>
                          <div style="flex:0 0 50px">
                            <div class="icon-delete-small" (click)="item.answers.splice(h, 1)" pTooltip="Delete Answer"
                                 tooltipPosition="top"></div>
                          </div>
                        </div>
                        <button mat-raised-button (click)="addControlItem(item.controlItems)" style="margin: 10px 0">
                          Recommend Controls
                        </button>
                        <p-table *ngIf="item.controlItems && item.controlItems.length"
                                 [value]="item.controlItems"
                                 [ngStyle]="{margin: '0 0 10px 0', display: 'block'}"
                        >

                          <ng-template pTemplate="header">
                            <tr style="white-space: nowrap;font-weight: bold">
                              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                                {{col.header}}
                              </th>
                              <th style="width:15em"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-controlItem>
                            <tr [pSelectableRow]="controlItem">
                              <td *ngFor="let col of cols">{{controlItem[col.field]}}</td>
                              <td>
                                <button
                                  type="button"
                                  pButton
                                  class="risksponge-button"
                                  (click)="removeControlItem(item, controlItem)"
                                  pTooltip="Remove Control Item" tooltipPosition="top"
                                  icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                      <button mat-raised-button (click)="addAnswer(item.answers)">Add Answer</button>
                      <button mat-raised-button (click)="item.multiple = false">Change to Radio-buttons</button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px;" class="controls">
              <button mat-raised-button (click)="addQuestion(step.items)">Add Question</button>
              <button mat-raised-button (click)="addAttachment(step.items)">Add Attachment</button>
              <button mat-raised-button (click)="addTextQuestion(step.items)">Add Text Question</button>
              <button mat-raised-button (click)="addYesNoQuestion(step.items)">Add Yes/No Question</button>
              <button mat-raised-button (click)="send()">Save</button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Users" *ngIf="this.quiz.id">
    <div style="margin-top: 20px;" class="controls">
      <button mat-raised-button (click)="invite()">Manage Users</button>
    </div>

    <p-table [value]="users"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             selectionMode="multiple"
             [(selection)]="assignedUsers"
    >
      <ng-template pTemplate="caption">
        <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center">
          <mat-form-field>
            <mat-label>From Date</mat-label>
            <input matInput
                   [matDatepicker]="fromDatePicker"

                   name="identificationDate"
                   [(ngModel)]="fromDate"
                   required>

            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>To Date</mat-label>
            <input matInput
                   [matDatepicker]="toDatePicker"

                   name="identificationDate"
                   [(ngModel)]="toDate"
                   required>

            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>

          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-file-excel"
                  iconPos="left"
                  label="Export Results"
                  (click)="exportAnswers()"
                  style="float:right">
          </button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr [ngStyle]="{'white-space': 'nowrap'}">
          <th style="width: 3em;"></th>
          <th>Name</th>
          <th>Active</th>
          <th>Email</th>
          <th>Company</th>
          <th>Frequency</th>
          <th>Last Completed</th>
          <th>Next Due</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <p-tableCheckbox [value]="item"></p-tableCheckbox>
          </td>
          <td>{{getFullName(item)}}</td>
          <td>
            <i *ngIf="item.assessmentUserId" class="pi pi-check"></i>
          </td>
          <td>{{item.emailAddress}}</td>
          <td>{{item.companyName}}</td>
          <td>
            <mat-select *ngIf="item.assessmentUserId" [value]="item.frequency"
                        (selectionChange)="updateFrequency(item, $event.value)">
              <mat-option [value]="option.value" *ngFor="let option of recurringList">{{option.label}}</mat-option>
            </mat-select>
          </td>
          <td>
            <mat-select [value]="item.answers[0]" *ngIf="item.answers.length">
              <mat-select-trigger>
                <div style="text-decoration: underline; cursor: pointer"
                     (click)="open(item.answers[0]); $event.cancelBubble = true">{{item.answers.length > 0 ? (item.answers[0].date | date: 'shortDate') + ' ' + (item.answers[0].date | date: 'shortTime') : ''}}</div>
              </mat-select-trigger>
              <mat-option [value]="option" *ngFor="let option of item.answers"
                          (click)="open(option); $event.cancelBubble = true">{{option.date | date : 'shortDate'}} {{option.date | date : 'shortTime'}}</mat-option>
            </mat-select>
          </td>
          <td>
            <div>{{item.nextDate | date: 'shortDate'}}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <br />
    <h4>Email Users
      <div class="tooltip-trigger"
           pTooltip='The message that you type below will only send to the user(s) that you select above.  Select a user by cilcking the box to the left of the survey user&apos;s name.'>

      </div>
    </h4>
    <p-editor matInput
              type="text"
              name="references"
              [(ngModel)]="inviteText"
              #description="ngModel">
      <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
        <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
        <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
        <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
        <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
        <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
      </p-header>
    </p-editor>

    <div style="margin-top: 20px;" class="controls">
      <button mat-raised-button (click)="sendInvite()">Invite</button>
    </div>
  </mat-tab>
</mat-tab-group>
